import { AssessmentType } from '@@types/api.types';
import { Tile } from '@components/shared/tile.component';
import {
  TrlAcrossDomainsBarChartComponent,
  computeDataGroups,
} from '@components/shared/trl-across-domains-bar-chart.component';
import { cn } from '@lib/utils';
import { useAssessmentsQueryOptions } from '@queries/assessment.query';
import { useGetTechnology } from '@queries/technology.query';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useReadinessTab } from '../../shared/use-readiness-tab';

type UsesPerformanceBarTileProps = {
  technologyId: string;
};

export const UsesPerformanceBarTile: FC<UsesPerformanceBarTileProps> = (props) => {
  const { technologyId } = props;
  const { selectAssessment } = useReadinessTab({ assessmentIdParam: 'assessmentId', tabParam: 'trlTab' });

  const { data: technology, isPending: isTechnologyLoading } = useGetTechnology(technologyId);
  const assessmentQueryOptions = useAssessmentsQueryOptions({
    technologyId,
    type: [AssessmentType.TRL],
  });
  const { data: assessments = [], isPending: isAssessmentsLoading } = useQuery(assessmentQueryOptions);

  const { hasData } = computeDataGroups({ assessments, technology });

  const handleItemClick = (assessmentId: string) => {
    selectAssessment(assessmentId);
  };

  return (
    <Tile
      emptyState={{ title: 'No TRL Assessments' }}
      header={{ title: 'Uses TRL Performance Across Domains' }}
      isEmpty={!hasData}
      isLoading={isTechnologyLoading || isAssessmentsLoading}
    >
      <div className={cn('rounded-md p-4', hasData ? 'bg-[#F5F5F5]' : 'bg-white')}>
        <TrlAcrossDomainsBarChartComponent
          onItemClick={handleItemClick}
          technology={technology}
        />
      </div>
    </Tile>
  );
};
